<ul
  class="w-full flex flex-col items-center justify-start space-y-2 divide-y-2"
>
  <li *ngFor="let element of source" class="w-full">
    <p class="w-full text-sm">{{ element[item] }}</p>
  </li>
</ul>
